/**
 * @name BackupService
 * @description Servicio para la gestión de backups
 * @author Gerado de León
 */

import axios from 'axios';
import { Environment } from '@config';

// URL Administración Endpoint
const BASE_URL = `${Environment.getCurrent().endpoints.orgChart}/Administracion/Backup`;
const BASE_URLRESP = `${Environment.getCurrent().endpoints.orgChart}/Administracion`;

/**
 * Consulta los backup de un usuario
 * @return {any} promise
 */
const get = (filters) => {
  let backupId = filters && filters.backup ? `&IdEmpleadoBackup=${filters.backup}` : '';
  let responsabilityId = filters && filters.responsability ? `&idResponsabilidad=${filters.responsability}` : '';
  let fechaInicio = filters && filters.startDate && filters.startDate !== '' ? `&fechaInicio=${filters.startDate}` : '';
  let fechaFin = filters && filters.endDate && filters.endDate !== '' ? `&fechaFin=${filters.endDate}` : '';
  let id = filters && filters.status ? `&idEstatusBackup=${filters.status}` : '';

  let URL = `${BASE_URL}?paginado=0,0${backupId}${responsabilityId}${fechaInicio}${fechaFin}${id}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta los backup asignados de un usuario
 * @return {any} promise
 */
const getAssigments = (filters) => {
  let backupId = filters && filters.employee ? `&idEmpleado=${filters.backup}` : '';
  let responsabilityId = filters && filters.responsability ? `&idResponsabilidad=${filters.responsability}` : '';
  let fechaInicio = filters && filters.startDate && filters.startDate !== '' ? `&fechaInicio=${filters.startDate}` : '';
  let fechaFin = filters && filters.endDate && filters.endDate !== '' ? `&fechaFin=${filters.endDate}` : '';
  let id = filters && filters.status ? `&idEstatusBackup=${filters.status}` : '';

  let URL = `${BASE_URL}Asignado?paginado=0,0${backupId}${responsabilityId}${fechaInicio}${fechaFin}${id}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Consulta las responsabilidades para los backups
 * @return {any} promise
 */
const getResponsabilieties = (idEmpleado) => {
  let employeeId = idEmpleado === undefined ? '' : `?idEmpleado=${idEmpleado}`;
  let URL = `${BASE_URLRESP}/BackupResponsabilidades${employeeId}`;

  return axios.get(URL).then(({ data }) => {
    return data;
  });
};

/**
 * Registra un backup
 * @param {any} request { IdEmpleaoBackup, Fecha Inicio, Fecha Fin, Comentario }
 * @return {any} promise
 */
const post = (request) => {
  let URL = `${BASE_URL}`;

  return axios.post(URL, request).then(({ data }) => {
    return data;
  });
};

/**
 * Cancelar o rechazar un backup
 * @param {any} request { IdBackup, Comentario, Estatus }
 * @return {any} promise
 */
const put = (request) => {
  let URL = `${BASE_URL}RechazarCancelar`;

  return axios.put(URL, request).then(({ data }) => {
    return data;
  });
};

export const BackupService = {
  get,
  getAssigments,
  getResponsabilieties,
  post,
  put
};